import Accordion from "components/accordion/Accordion";
import { Asset, AssetSuspect } from "types";

interface SuspectMappingDisplayProps {
  suspectAssetCounts: any[];
  totalAssets?: number;
  showAddButton?: boolean;
  onAddSuspect?: () => void;
  isAssetProsecutor?: boolean;
}

export default function SuspectMappingDisplay({
  suspectAssetCounts,
  totalAssets = 0,
  showAddButton = false,
  onAddSuspect,
  isAssetProsecutor = false,
}: SuspectMappingDisplayProps) {
  if (!suspectAssetCounts || suspectAssetCounts.length === 0) {
    return (
      <div className="text-center py-8 bg-gray-50 rounded-lg border border-dashed">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
        <p className="mt-2 text-sm text-gray-500">No suspects added yet</p>
        {isAssetProsecutor && (
          <button
            type="button"
            onClick={onAddSuspect}
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-black-700 bg-black-100 hover:bg-black-200"
          >
            Add Suspect Mapping
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {suspectAssetCounts.map((suspectAssetCount) => {
        const suspects = suspectAssetCount.asset_suspects || [];
        const assets = suspectAssetCount.assets || [];

        const suspectNames =
          suspects.length > 0
            ? suspects.map((s: AssetSuspect) => s.person?.full_name).join(", ")
            : "No suspect assigned";

        return (
          <Accordion
            key={suspectAssetCount.id}
            mainTitle="Suspect:"
            title={suspectNames}
            defaultOpen={false}
          >
            {assets.length > 0 ? (
              <div className="space-y-3">
                <p className="text-sm font-medium text-gray-700">
                  Associated Assets ({assets.length}):
                </p>
                <div className="space-y-2">
                  {assets.map((asset: Asset) => (
                    <div
                      key={asset.id}
                      className="p-3 bg-gray-50 rounded-lg border"
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <p className="text-sm text-gray-900 font-medium">
                            {asset.asset_unique_id}
                          </p>
                        </div>
                        <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs font-medium rounded-full ml-2">
                          Asset
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex justify-end mt-2">
                  <span className="px-3 py-1 bg-black-100 text-black-800 text-xs font-medium rounded-full">
                    Suspect Count: {suspectAssetCount.suspect_count}
                  </span>
                </div>
              </div>
            ) : (
              <div className="text-center py-4 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-500 italic">
                  No assets associated with this suspect
                </p>
              </div>
            )}
          </Accordion>
        );
      })}

      {/* Summary Section */}
      <div className="mt-4 pt-3 border-t border-gray-200">
        <div className="flex justify-between text-sm text-gray-600">
          <p>Total suspect groups: {suspectAssetCounts.length}</p>
          <p>Total assets: {totalAssets}</p>
        </div>
      </div>

      {/* Optional: Add button even when there are existing suspects */}
      {/* {isAssetProsecutor && (
        <div className="flex justify-center mt-4">
          <button
            type="button"
            onClick={onAddSuspect}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-black-700 bg-black-100 hover:bg-black-200"
          >
            Add Suspect Mapping
          </button>
        </div>
      )} */}
    </div>
  );
}
